import { render, staticRenderFns } from "./filteredNavigation.vue?vue&type=template&id=d60c4d34&scoped=true"
import script from "./filteredNavigation.vue?vue&type=script&lang=js"
export * from "./filteredNavigation.vue?vue&type=script&lang=js"
import style0 from "./filteredNavigation.vue?vue&type=style&index=0&id=d60c4d34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d60c4d34",
  null
  
)

export default component.exports